import React from 'react';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { ROUTES } from '~/consts';
import { GERENTE_SOMA, VENDEDOR_SOMA } from '~/util/perfilId';
import { FOXTON } from '~/util/brands';

export default function getReportsMenuItems({
    user,
    generatedMenuIcons,
    redirect,
}) {
    const isGerenteFoxton =
        user?.id_perfil === GERENTE_SOMA && user?.marcaFilial === FOXTON;
    const isVendedorFoxton =
        user?.id_perfil === VENDEDOR_SOMA && user?.marcaFilial === FOXTON;
    const show = isGerenteFoxton || isVendedorFoxton;
    const route = isGerenteFoxton
        ? ROUTES.MANAGER_REPORTS
        : ROUTES.SELLER_REPORTS;

    const insertBeforeText = isGerenteFoxton ? 'Operacional Omni' : 'BOX';
    const insertBeforeIndex = generatedMenuIcons.findIndex(
        icon => icon?.text === insertBeforeText
    );

    return {
        insertIndex:
            insertBeforeIndex === -1
                ? generatedMenuIcons.length
                : insertBeforeIndex,
        items: [
            {
                name: <AssessmentOutlinedIcon />,
                position: null,
                text: 'Relatórios Now',
                show,
                action: () => redirect(route),
                route,
            },
        ],
    };
}
